export const fontsKeys = {
  Arial: 'Arial',
  ArialBlack: 'ArialBlack',
  CourierNew: 'CourierNew',
  Georgia: 'Georgia',
  LucidaSansUnicode: 'LucidaSansUnicode',
  Tahoma: 'Tahoma',
  TimesNewRoman: 'TimesNewRoman',
  TrebuchetMS: 'TrebuchetMS',
  Verdana: 'Verdana',
}

export const fontsValues = {
  [fontsKeys.Arial]: 'arial, helvetica, sans-serif',
  [fontsKeys.ArialBlack]: 'Arial Black, Gadget, sans-serif',
  [fontsKeys.CourierNew]: 'courier new,courier,monospace',
  [fontsKeys.Georgia]: 'georgia, serif',
  [fontsKeys.LucidaSansUnicode]: 'Lucida sans unicode,lucida grande,sans-serif',
  [fontsKeys.Tahoma]: 'tahoma,geneva,sans-serif',
  [fontsKeys.TimesNewRoman]: 'times new roman,times,serif',
  [fontsKeys.TrebuchetMS]: 'trebuchet ms,helvetica,sans-serif',
  [fontsKeys.Verdana]: 'verdana,geneva,sans-serif',
}

export const fontLabels = {
  [fontsKeys.Arial]: 'Arial',
  [fontsKeys.ArialBlack]: 'Arial Black',
  [fontsKeys.CourierNew]: 'Courier New',
  [fontsKeys.Georgia]: 'Georgia',
  [fontsKeys.LucidaSansUnicode]: 'Lucida',
  [fontsKeys.Tahoma]: 'Tahoma',
  [fontsKeys.TimesNewRoman]: 'Times New Roman',
  [fontsKeys.TrebuchetMS]: 'Trebuchet MS',
  [fontsKeys.Verdana]: 'Verdana',
}

export function findFontKeyByValue(value: string) {
  return Object.keys(fontsValues).find(key => fontsValues[key] === value)
}
